var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prt-toast",class:[_vm.color],on:{"click":_vm.handleBubbleClick}},[_c('span',[_vm._v(_vm._s(_vm.content))]),(_vm.callback && _vm.action)?_c('button',{attrs:{"aria-label":_vm.action},on:{"click":_vm.fireCallback}},[_vm._v(_vm._s(_vm.action))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }